import React from 'react';
import { loginUser, setUsername, setPassword, setLoginError } from '../../actions';
import { connect } from 'react-redux';
import '../../App.css';

const Form = props => {

  const onSubmit = async () => {
    if(props.username && props.username.trim().length > 0 && props.password && props.password.trim().length > 0){
      if(props.username.includes('@') && props.username.includes('.')){
        props.loginUser(props.username,props.password,null);
      } else {
        props.setLoginError('username must be in a valid email format.');
      }
    } else {
      props.setLoginError('must provide username and password.');
    };
  };

  return (
     <div style={styles.containerStyle}>
      <h1 style={styles.headingStyle}>Login</h1>
      <hr style={{ ...styles.dividerStyle, marginBottom: 10 }} />
      <p style={{...styles.errorTextStyle, backgroundColor: props.loginError.length > 0 ? 'rgba(255,255,255,0.9)' : 'transparent' }}>{props.loginError}</p>

      <div style={{...styles.inputContainerStyle, marginTop: 10 }}>
        <p style={styles.inputLabelStyle} >username</p>
        <input
          type="email"
          name="username"
          value={props.username}
          autoFocus={true}
          autoComplete={'username'}
          onChange={ e => props.setUsername(e.target.value) }
          placeholder="enter email address"
          style={styles.inputStyle} />
      </div>

      <div style={{ ...styles.inputContainerStyle, marginBottom: 30 }}>
        <p style={styles.inputLabelStyle} >password</p>
        <input
          type="password"
          name="password"
          value={props.password}
          autoComplete={'current-password'}
          onChange={ e => props.setPassword(e.target.value) }
          placeholder="enter password"
          onKeyDown={ (event) => { 
              if (event.keyCode === 13) {
                onSubmit();
              };
            }
          }
          style={styles.inputStyle}  />
      </div>

      <hr style={{ ...styles.dividerStyle, marginBottom: 20 }} />

      <button 
        onClick={props.loading && !props.loginError ? null : onSubmit} 
        style={{...styles.submitButtonStyle, fontSize: props.loading && ! props.loginError ? 12 : 16 }}
        className="cursor-pointer">
        { props.loading && ! props.loginError ? 'attempting login ...' : 'LOGIN' }
      </button>

    </div>
  )
}

const mapStateToProps = state => {
  const { loginError, loading, username, password } = state.auth;

  return {
    loginError,
    username, 
    password,
    loading
  }
}

export default connect(mapStateToProps, { loginUser, setUsername, setPassword, setLoginError })(Form);

const styles = {
  containerStyle: {
    padding: 10, 
    textAlign: 'center'
  },
  headingStyle: {
    color: 'white', 
    textAlign: 'center', 
    margin: 0, 
    padding: 0, 
    marginBottom: 10,
    fontSize: '3vmin'
  },
  dividerStyle: {
    boxShadow: '0 1px 1px #000033'
  },
  inputContainerStyle: {
    position: 'relative',
    width: '80%',
    maxWidth: 280,
    margin: 'auto',
    marginBottom: 10,
    marginTop: 5
  },
  errorTextStyle: {
    color: '#ff4d4d', 
    padding: '3px 0', 
    fontWeight: 'bold',
    borderRadius: 5,
    width: '80%',
    margin: 'auto',
    fontSize: '1.6vmin'
  },
  inputLabelStyle: {
    textAlign: 'left',
    margin: 0,
    marginBottom: 8,
    color: 'white',
    fontWeight: 'bold',
    fontSize: '1.6vmin'
  },
  inputStyle: {
    padding: 3, 
    width: '100%',
    borderRadius: 5,
    fontSize: '1.6vmin'
  },
  submitButtonStyle: {
    padding: 3, 
    width: '80%',
    maxWidth: 200,
    marginBottom: 10,
    fontSize: '1.6vmin',
    borderRadius: 5,
    cursor: 'pointer'
  }
}